<script>
  import gql from 'graphql-tag'

  export default {
    props: {
      gid: {
        type: String,
        required: false
      },
      label: {
        type: String,
        required: true
      },
      subLabel: {
        type: String,
        required: false
      },
      settingField: {
        type: String,
        required: true
      },
      mutationAttribute: {
        type: String,
        required: true
      },
      initialState: {
        type: String,
        required: true
      },
      options: {
        type: Array,
        required: true
      }
    },
    data() {
      return {
        current: this.initialState,
        previous: this.initialState
      }
    },
    methods: {
      onChange() {
        const input = {
          [this.mutationAttribute]: this.current
        }

        this.$apollo.mutate({
          mutation: gql`
            mutation updatePaySettings($input: PayAttributes!, $gid: ID) {
              updatePaySettings(input: {settings: $input, userId: $gid}) {
                paySettings {
                  ${this.settingField}
                }
                errors
              }
            }
          `,
          variables: {
            input,
            gid: this.gid
          }
        }).then(result => {
          if (result.data.updatePaySettings.errors.length > 0) {
            this.notifyError(result.data.updatePaySettings.errors[0])
            this.current = this.previous
          } else {
            const persisted = result.data.updatePaySettings.paySettings[this.settingField]
            this.current = persisted
            this.previous = persisted
            this.$emit('input', persisted)
            this.notifySuccess("Settings successfully updated")
          }
        }).catch(error => {
          this.gqlErrorHandler(error)
          console.log(error)
          this.current = this.previous
        })
      }
    }
  }
</script>

<template>
  <div>
    <section>
      <div class="very-close-lines">
        {{ label }}<br>
        <small v-if="subLabel" class="grey-text">{{ subLabel }}</small>
      </div>
      <select
        v-model="current"
        @change="onChange"
        class="browser-default mt-5"
        :disabled="$apollo.loading">
        <option v-for="opt in options" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
      </select>
    </section>
  </div>
</template>
